module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bvDtn"))).then(() => module.bundle.root('hEqeo'));